import React from 'react'
import { connect } from 'react-redux'

import {
    loadObjects,
    toggleSelectedObject,
    checkAndLoadObject
} from '../../store/Objects/actions'
import { toggleSelectedObjectState } from '../../store/Reports/actions'

import Objects from './Objects'
import { getObjectGroupsState, getObjectsState, getTracksObjectsState } from '../../store/Search/extraSelectors'



const ObjectsContainer = props => (
    <Objects
        className={props.className}
        types={props.types}

        allObjects={props.allObjects}
        trackObjects={props.trackObjects}
        searchFounded={[]}

        selectedObjects={props.selectedObjects}
        selectedTracks={props.selectedTracks}

        loading={props.loading}
        searchActive={props.searchValue}

        loadObjects={props.loadObjects}
        checkAndLoadObject={props.checkAndLoadObject}
        toggleSelectedObject={props.toggleSelectedObject}
        toggleSelectedObjectState={props.toggleSelectedObjectState}
    />
)

const stateToProps = state => ({
    allObjects: getObjectsState(state),
    trackObjects: getTracksObjectsState(state),
    searchValue: state.search["objects"].value || null,
    selectedObjects: [...state.objects.selected],
    selectedTracks: state.tracks.selected,
    loading: state.objects.loading,
    searchActive: state.search["objects"].modeActive,
})

const actionsToProps = {
    loadObjects,
    checkAndLoadObject,
    toggleSelectedObject,
    toggleSelectedObjectState
}

export default connect(stateToProps, actionsToProps)(ObjectsContainer)